import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Link } from 'react-router-dom';
import {
  Button,
  ButtonsContainer,
  ButtonWithLoader,
  InlineFormRow,
  Col,
  Paper,
  PaperTitle,
  PaperContent,
  RFFormCheckboxGroup,
  RFFormInput,
} from 'virtues-bootstrap';

import s from './styles.module.scss';
import { VALIDATE_FUNCTIONS } from './validate';

const OrganizationForm = ({
  doctors,
  siteId,
  handleSubmit,
  editMode,
  pristine,
  researchCoordinators,
  submitting,
  technicians,
  superResearchCoordinators,
  superTechnicians,
  isSuperCareteam,
}) => (
  <form onSubmit={handleSubmit}>
    <Paper>
      <PaperTitle withBorder>{editMode ? siteId : 'Add site'}</PaperTitle>
      <PaperContent>
        <InlineFormRow label="Site ID">
          <Col xs={6}>
            <Field
              component={RFFormInput}
              name="siteId"
              validate={[
                VALIDATE_FUNCTIONS.required,
                editMode ? () => undefined : VALIDATE_FUNCTIONS.integerPositive,
              ]}
              disabled={editMode}
            />
          </Col>
        </InlineFormRow>
        <InlineFormRow label="Site name">
          <Col xs={6}>
            <Field
              component={RFFormInput}
              name="name"
              disabled={editMode}
              validate={[VALIDATE_FUNCTIONS.required]}
            />
          </Col>
        </InlineFormRow>

        {isSuperCareteam ? (
          <React.Fragment>
            <InlineFormRow label="Super research coordinators">
              <Col xs={6} className={s.checkboxesGroupSeparator}>
                <RFFormCheckboxGroup
                  groupName="participants"
                  checkboxes={superResearchCoordinators}
                />
              </Col>
            </InlineFormRow>

            <InlineFormRow label="Super device clinicians">
              <Col xs={6} className={s.checkboxesGroupSeparator}>
                <RFFormCheckboxGroup groupName="participants" checkboxes={superTechnicians} />
              </Col>
            </InlineFormRow>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <InlineFormRow label="Research coordinators">
              <Col xs={6} className={s.checkboxesGroupSeparator}>
                <RFFormCheckboxGroup groupName="participants" checkboxes={researchCoordinators} />
              </Col>
            </InlineFormRow>

            <InlineFormRow label="Device clinicians">
              <Col xs={6} className={s.checkboxesGroupSeparator}>
                <RFFormCheckboxGroup groupName="participants" checkboxes={technicians} />
              </Col>
            </InlineFormRow>

            <InlineFormRow label="Doctors">
              <Col xs={6} className={s.checkboxesGroupSeparator}>
                <RFFormCheckboxGroup groupName="participants" checkboxes={doctors} />
              </Col>
            </InlineFormRow>
          </React.Fragment>
        )}
      </PaperContent>
    </Paper>
    <ButtonsContainer>
      <Button component={Link} to="/" variant="link">
        Cancel
      </Button>
      <ButtonWithLoader disabled={pristine} loading={submitting}>
        {editMode ? 'Edit site' : 'Add site'}
      </ButtonWithLoader>
    </ButtonsContainer>
  </form>
);

const CheckboxesType = PropTypes.arrayOf(
  PropTypes.shape({
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
);

OrganizationForm.defaultProps = {
  siteId: '',
};

OrganizationForm.propTypes = {
  siteId: PropTypes.string,
  editMode: PropTypes.bool.isRequired,
  doctors: CheckboxesType.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  researchCoordinators: CheckboxesType.isRequired,
  submitting: PropTypes.bool.isRequired,
  technicians: CheckboxesType.isRequired,
  superResearchCoordinators: CheckboxesType.isRequired,
  superTechnicians: CheckboxesType.isRequired,
  isSuperCareteam: PropTypes.bool.isRequired,
};

export default OrganizationForm;
